// Die Lage einer Anschrift auf der Pflegeseite Anschriften (ST-GEO-001 G1).
//
// Wortlaut und Form von DESIGN: eine Textzeile in der Metazeile nach "seit
// MM/JJJJ", davor ein Ortssymbol in 12 px; wo die Nutzerin etwas pruefen
// kann oder wissen muss, ein Warnsymbol statt des Ortssymbols und darunter der
// Satz dazu. Der Zustand steht immer in Worten, nie als Farbe oder Zeichen
// allein (NFR-ACC-001, WCAG 1.4.1); die Zeichen sind stumm. Der Satz folgt in
// der Lesereihenfolge direkt; ein aria-describedby an der nicht fokussierbaren
// Zeile wuerde nicht angesagt.

import { Caption1, makeStyles, tokens } from '@fluentui/react-components';
import type { ReactElement } from 'react';

import { ADDRESS_LOCATION_TEXT, type AddressLocationStatus } from '../addresses.ts';

const useStyles = makeStyles({
  lage: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    color: tokens.colorNeutralForeground2,
  },
  beschreibung: { display: 'block', marginTop: '0.25rem', color: tokens.colorNeutralForeground2, overflowWrap: 'anywhere' },
});

function Zeichen({ warnung }: { readonly warnung: boolean }): ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      // 12 px bei Standardschrift; in rem, damit das Zeichen mit dem Textzoom waechst.
      style={{ width: '0.75rem', height: '0.75rem', flexShrink: 0 }}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {warnung ? (
        <>
          <path d="M12 3.8 2.8 19.6h18.4z" />
          <path d="M12 9.8v4.4M12 17v.1" />
        </>
      ) : (
        <>
          <path d="M12 21s-6.5-6-6.5-11a6.5 6.5 0 0 1 13 0c0 5-6.5 11-6.5 11z" />
          <circle cx="12" cy="10" r="2.3" />
        </>
      )}
    </svg>
  );
}

/** Der Zustand in der Metazeile. */
export function Lage({ status }: { readonly status: AddressLocationStatus }): ReactElement {
  const own = useStyles();
  const text = ADDRESS_LOCATION_TEXT[status];
  return (
    <Caption1 className={own.lage}>
      <Zeichen warnung={text.warning} />
      {text.label}
    </Caption1>
  );
}

/** Der Satz unter der Metazeile; ohne Beschreibung nichts. */
export function LageBeschreibung({ status }: { readonly status: AddressLocationStatus }): ReactElement | null {
  const own = useStyles();
  const { description } = ADDRESS_LOCATION_TEXT[status];
  return description === undefined ? null : (
    <Caption1 className={own.beschreibung}>
      {description}
    </Caption1>
  );
}
